// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2OnHs","head":"ProcedureTableInfo_head__KGCNj"};